import { call, put } from 'redux-saga/effects';
// import { saveAs } from 'file-saver';
import notify from 'devextreme/ui/notify';
import { formatMessage } from 'devextreme/localization';
import * as action from '../actions/popupAct';
import {
  startLoading,
  stopLoading
} from '../actions/settings/loading';
import { modalErrorOpen } from '../actions/modalError';
// eslint-disable-next-line import/named
import { post, get } from '../../utils/api';

// Вызов всплывающего окна с сообщением
function openNotify(text) {
  notify(
    {
      message: text,
      height: 64,
      width: 354,
      position: {
        at: 'top center',
        my: 'top center',
        offset: '0 48'
      }
    },
    'success',
    2000
  );
}

export function* popupActReport({ payload }) {
  try {
    const data = window.btoa(unescape(encodeURIComponent(JSON.stringify({
      restMethod: 'getFile',
      url: `/reports/document?pKey=${payload.idAct}&docStatus=${payload.statusId}`
    }))));
    const newWindow = window.open(`/pdf-viewer/${data}`, '_blank');
    newWindow.opener = null;

    yield put(action.getPopupActReportSuccess(payload));
  } catch (error) {
    yield put(action.getPopupActReportFail(error.response.data));
  }
}

// Добавление особых отметок
export function* popupActAddNote({ payload }) {
  try {
    yield put(startLoading());
    yield call(
      post,
      '/documents/addnote',
      {
        idAct: payload.idAct,
        noteText: payload.noteText
      }
    );
    yield put(action.popupActAddNoteSuccess());
    yield call(openNotify, formatMessage('dataSuccess'));
    yield put(stopLoading());
  } catch (error) {
    yield put(stopLoading());
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}

// Получение особых отметок
export function* popupActGetNote({ payload }) {
  try {
    yield put(startLoading());
    const response = yield call(
      get,
      `/documents/note?idAct=${payload.idAct}`
    );
    yield put(action.popupActGetNoteSuccess(response));
    yield put(stopLoading());
  } catch (error) {
    yield put(stopLoading());
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}
